export default "__VITE_ASSET__CnsF1X5y__"